import {
  ExamCourseSettingsAlert,
  ExamCourseSettingsDetails,
} from '@exam-center/admin-exam-course-details';
import { useParams } from '@exam-center/router';
import { Flex } from '@shared/components';

export default function AdminExamCourseDetailsPage() {
  const { examCourseCode } = useParams('/admin/exam-courses/:examCourseCode/details');

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        bgcolor: theme.palette.grey[50],
        p: theme.spacing(6),
        gap: theme.spacing(6),
      })}
    >
      <ExamCourseSettingsAlert />
      <ExamCourseSettingsDetails examCourseCode={examCourseCode} />
    </Flex>
  );
}
